module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/lead/lead.component.html
// module id = ./src/app/Pages/lead/lead.component.html
// module chunks = main